import $ from "jquery";
// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.
// You can use CoffeeScript in this file: http://coffeescript.org/

// These functions are now handled by the batch-actions Stimulus controller
// window.toggle_actions and window.update_action_count are no longer needed

// Disable all inherited checkboxes for payers and admins on load
const adjust_inherited_privileges = function () {

    $('.must-pay-radio').each(function () {
        // Disable/enable admin checkbox if this is/not the payer
        $(this).closest('.row').find('.can-admin-checkbox').prop('disabled', $(this).is(':checked'));
        // Check admin if this is the payer
        if ($(this).is(':checked')) {
            return $(this).closest('.row').find('.can-admin-checkbox').prop('checked', true);
        }
    });

    return $('.can-admin-checkbox').each(function () {
        // Disable/enable edit checkbox if this is/not the admin
        $(this).closest('.row').find('.can-edit-checkbox').prop('disabled', $(this).is(':checked'));
        // Check edit if this is the admin
        if ($(this).is(':checked')) {
            return $(this).closest('.row').find('.can-edit-checkbox').prop('checked', true);
        }
    });
};

// Disable all inherited checkboxes for payers and admins on load
const adjust_public_share_opacity = function () {

    // Reduce opacity if the project is not shared publicly
    const checked = $('.publicly-shared-radio:checked').val() === "true";
    const link = $('.publicly-shared-radio').closest('.row').find('.link');
    if (checked) {
        return link.css({ opacity: 0.25 });
    } else {
        return link.css({ opacity: 1 });
    }
};

$(function () {

    // Projects page
    if ($('#controller-projects').length === 0) {
        return;
    }






    //###########################

    // Focus seach field after opening search dialog
    $(document).on('click', '[data-target="#search_variant"]', () => setTimeout(() => $('#search_variant').find('input[type=search]:visible').focus()
        , 250));
    // Focus search field after switching tabs
    $(document).on('click', '#search_variant .tabs a', () => setTimeout(() => $('#search_variant').find('input[type=search]:visible').focus()
        , 50));






    adjust_inherited_privileges();

    adjust_public_share_opacity();

    // Batch actions are now handled by the batch-actions Stimulus controller



    $('.publicly-shared-radio').on('change', () => adjust_public_share_opacity());

    $('.can-admin-checkbox').on('change', () => adjust_inherited_privileges());

    // Payment assigned
    $('.must-pay-radio').on('change', function () {

        const row = $(this).closest('.row');

        // Uncheck all other radios
        $('.must-pay-radio').prop('checked', false);
        // Check radio manually (needed for FF)
        $(this).prop('checked', true);

        // Enable all other's privileges
        return adjust_inherited_privileges();
    });

    // New user focussed
    $('#new_user').on('focus', function () {
        $('.hide-for-new-user').hide();
        $('.pale-for-new-user').css({ opacity: 0.25 });
        $('.show-for-new-user').show();
        return $('.show-for-new-user').find('input:text').focus();
    });

    // New user unfocussed
    return $('#cancel_new_user').on('click', function () {
        $('.show-for-new-user').hide();
        $('.pale-for-new-user').css({ opacity: 1 });
        $('.hide-for-new-user').show();
        $('.must-pay-radio').each(function () {
            return $(this).prop('checked', $(this).data('original-value'));
        });
        return false;
    });
});

$.fn.sort_list = function (key, order) {

    const ul = this;

    const items = this.find('li').get();

    items.sort(function (a, b) {

        const key_a = $(a).data(key);
        const key_b = $(b).data(key);

        if (order === "desc") {

            if (key_a > key_b) {
                return -1;
            }

            if (key_a < key_b) {
                return 1;
            }

        } else {

            if (key_a < key_b) {
                return -1;
            }

            if (key_a > key_b) {
                return 1;
            }
        }

        return 0;
    });

    return $.each(items, (i, li) => ul.append(li));
};

